function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
/* eslint-disable no-param-reassign */
/**
 * 补零
 * @param v 初始数字
 * @param l 补完0后长度 defaul:2
 */
export var patchZero = function patchZero(n) {
  var l = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var value = n.toString();
  var str = '';
  for (var i = value.length; i < l; i++) {
    str += '0';
  }
  return "".concat(str).concat(value);
};

/**
 * 生成随机数
 * @minNum到maxNum的随机数
 */
export var randomNum = function randomNum(minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return Math.random() * minNum + 1;
    case 2:
      return Math.random() * (maxNum - minNum + 1) + minNum;
    default:
      return 0;
  }
};

/**
 * localStorage方法封装
 */
export var LStorage = {
  set: function set(key, value) {
    if (!value) {
      value = '';
    }
    if (_typeof(value) === 'object' || typeof value === 'function') {
      value = JSON.stringify(value);
    }
    return localStorage.setItem(key, value);
  },
  get: function get(key) {
    var value = localStorage.getItem(key);
    if (!value) {
      return null;
    }
    try {
      var obj = JSON.parse(value);
      return obj;
    } catch (error) {
      return value;
    }
  },
  remove: function remove(key) {
    localStorage.removeItem(key);
  },
  clear: function clear() {
    localStorage.clear();
  }
};

/**
 * 获取domain
 * @param host host
 * @param length 将要返回的长度
 * @returns {string} domain
 */
export var getDomain = function getDomain() {
  var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var arr = host.split('.');
  if (arr.length > length) {
    return '.' + arr.slice(arr.length - length, arr.length).join('.');
  }
  return '.' + host;
};